export const sumByAttribute = <T>(values: Array<T>, key: keyof T) => {
  return values.reduce((acc: number, el: T) => acc + Number(el[key]), 0);
};

export default null; // silence a false warning
